import { emptyAdminApi as api } from "../emptyAdminApi";

export type AdminPortalRole = "user" | "admin";

export type AdminPortalUser = {
  username: string;
  email?: string;
  name?: string;
  profile: AdminPortalRole;
  enabled: boolean;
  status?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type ListAdminPortalUsersResponse = {
  users: AdminPortalUser[];
};

export type GetCurrentAdminPortalUserResponse = {
  user: AdminPortalUser;
};

export type SaveAdminPortalUserRequest = {
  username: string;
  email: string;
  name?: string;
  profile: AdminPortalRole;
  enabled?: boolean;
  temporaryPassword?: string;
  suppressInvite?: boolean;
};

export type SaveAdminPortalUserResponse = {
  user: AdminPortalUser;
};

export type ResetAdminPortalUserPasswordResponse = {
  username: string;
  message: string;
};

export const addTagTypes = ["AdminPortalUsers"] as const;

const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getCurrentAdminPortalUser: build.query<GetCurrentAdminPortalUserResponse, void>({
        query: () => ({
          url: "/portal/users?action=me",
          method: "GET",
        }),
      }),
      getAdminPortalUsers: build.query<ListAdminPortalUsersResponse, void>({
        query: () => ({
          url: "/portal/users",
          method: "GET",
        }),
        providesTags: ["AdminPortalUsers"],
      }),
      createAdminPortalUser: build.mutation<SaveAdminPortalUserResponse, SaveAdminPortalUserRequest>({
        query: (body) => ({
          url: "/portal/users",
          method: "POST",
          body,
        }),
        invalidatesTags: ["AdminPortalUsers"],
      }),
      updateAdminPortalUser: build.mutation<SaveAdminPortalUserResponse, SaveAdminPortalUserRequest>({
        query: (body) => ({
          url: "/portal/users",
          method: "PUT",
          body,
        }),
        invalidatesTags: ["AdminPortalUsers"],
      }),
      disableAdminPortalUser: build.mutation<{ username: string; enabled: boolean }, string>({
        query: (username) => ({
          url: "/portal/users?username=" + encodeURIComponent(username),
          method: "DELETE",
        }),
        invalidatesTags: ["AdminPortalUsers"],
      }),
      resetAdminPortalUserPassword: build.mutation<ResetAdminPortalUserPasswordResponse, string>({
        query: (username) => ({
          url: "/portal/users?action=reset-password",
          method: "POST",
          body: { username },
        }),
      }),
    }),
  });

export const {
  useGetCurrentAdminPortalUserQuery,
  useGetAdminPortalUsersQuery,
  useCreateAdminPortalUserMutation,
  useUpdateAdminPortalUserMutation,
  useDisableAdminPortalUserMutation,
  useResetAdminPortalUserPasswordMutation,
} = injectedRtkApi;
